interface RasterIconProps {
  size?: number;
}

const circles: Array<{ cx: number; cy: number; r: number }> = [
  { cx: 14.6667, cy: 22.6667, r: 1.3333 },
  { cx: 10.6667, cy: 18.6667, r: 1.3333 },
  { cx: 3, cy: 19, r: 1 },
  { cx: 6.3333, cy: 22.3333, r: 1 },
  { cx: 10.3333, cy: 10.3333, r: 1.6667 },
  { cx: 15.6667, cy: 14.3333, r: 1.6667 },
  { cx: 21.6667, cy: 19, r: 1.6667 },
  { cx: 20.6667, cy: 8.6667, r: 2 },
  { cx: 15.3333, cy: 4.6667, r: 2 },
  { cx: 6.6667, cy: 14.6667, r: 1.3333 },
  { cx: 0.6667, cy: 23.3333, r: 0.6667 },
];

const RasterIcon = ({ size = 24 }: RasterIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="-2 -2 28 28"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    xmlns="http://www.w3.org/2000/svg"
  >
    {circles.map((c, i) => (
      <circle key={i} cx={c.cx} cy={c.cy} r={c.r} />
    ))}
  </svg>
);

export default RasterIcon;
